import { useReducer } from 'react';
import reducer, { defaultState } from './reducer';

export default function useSearchState() {
  return useReducer(reducer, defaultState);
}
